import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/dashboard';

export function useDashboardData(filters = {}) {
  return useQuery({
    queryKey: ['dashboard', filters],
    queryFn: () => dashboardApi.getSummary(filters),
    refetchInterval: 5 * 60 * 1000, // Refresh every 5 minutes
    staleTime: 2 * 60 * 1000, // Consider data stale after 2 minutes
  });
}
